import { useContext, useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { MapContext, MousePosition } from 'os-elements';
import { format } from 'ol/coordinate';
import { DESKTOP } from 'client/utils/constants/GDS/js/devices';
import { useMapScale } from '../../hooks/useMapScale';
import useDeviceType from 'client/utils/helpers/DeviceType/useDeviceType';

import styles from './MapInfo.module.scss';

const MapInfo = () => {
    const coordRef = useRef(null);
    const scale = useMapScale();
    const [coord, setCoord] = useState([0, 0]);
    const deviceType = useDeviceType();
    const { map } = useContext(MapContext);
    const intl = useIntl();

    useEffect(() => {
        map.on('postrender', updateInfo);
        return () => {
            map.un('postrender', updateInfo);
        };
    }, []);

    const updateInfo = () => {
        const center = map?.getView?.().getCenter?.();
        if (!center || center.length < 2) {
            return;
        }

        if (coord[0] !== center[0] && coord[1] !== center[1]) {
            setCoord(center);
        }
    };

    return (
        <div data-testid="mapInfo" className={styles.container}>
            <div data-testid="mapInfo.scale" className={['govuk-body-s', styles.scale].join(' ')}>
                {`${intl.formatMessage({ id: 'mapInfo.scale' })}: 1:${Math.round(scale)}`}
            </div>
            <div data-testid="mapInfo.coords" className={['govuk-body-s', styles.coord].join(' ')}>
                <div ref={coordRef}/>
                { deviceType === DESKTOP
                    ? <MousePosition
                        coordinateFormat={coordinate => format(coordinate, intl.formatMessage({ id: 'mapInfo.coordinates' }) + ': {x}, {y}', 2)}
                        target={coordRef.current}
                    />
                    : `${intl.formatMessage({ id: 'mapInfo.center' })}: ${coord[0].toFixed(2)}, ${coord[1].toFixed(2)}`
                }
            </div>
        </div>
    );
};

export default MapInfo;
